import { Injectable } from '@angular/core';
import { Logger } from './logger';
import { environment } from '@env/environment';

/**
 * Logger Factory - used for getting the logger
 */
@Injectable()
export class LoggerFactory {
  /**
   * Function used for retrieving the logger object
   * @param name string, name of the logger
   * @param prod boolean, is it prod env or not
   * @returns Logger object
   */
  public getLogger(name: string, prod?: boolean): Logger {
    if (prod === undefined) {
      prod = environment.production;
    }
    return new Logger(name, prod);
  }
}
